import { mutator } from 'satcheljs';
import store from '../store/store';
import removeMessageAdList from '../actions/removeMessageAdList';
export default mutator(removeMessageAdList, function (actionMessage) {
    store.listRemoved = true;
});
//# sourceMappingURL=removeMessageAdListMutator.js.map